import React, {useMemo} from 'react';
import styled from 'styled-components';
import useTokenBalance from '../../hooks/useTokenBalance';
import {getDisplayBalance} from '../../utils/formatBalance';

import Label from '../Label';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';
import useTombFinance from '../../hooks/useTombFinance';
import TokenSymbol from '../TokenSymbol';

const AccountModal = () => {
    const tombFinance = useTombFinance();

    const tombBalance = useTokenBalance(tombFinance.TOMB);
    const displayTombBalance = useMemo(() => getDisplayBalance(tombBalance), [tombBalance]);

    const tshareBalance = useTokenBalance(tombFinance.TSHARE);
    const displayTshareBalance = useMemo(() => getDisplayBalance(tshareBalance), [tshareBalance]);

    const tbondBalance = useTokenBalance(tombFinance.TBOND);
    const displayTbondBalance = useMemo(() => getDisplayBalance(tbondBalance), [tbondBalance]);

    return (
        <Modal>
            <ModalTitle text="My Wallet"/>

            <Balances>
                <StyledBalanceWrapper>
                    <TokenSymbol symbol="TOMB"/>
                    <StyledBalance>
                        <StyledValue>{displayTombBalance}</StyledValue>
                        <Label text="FUDGE Available"/>
                    </StyledBalance>
                </StyledBalanceWrapper>

                <StyledBalanceWrapper>
                    <TokenSymbol symbol="TSHARE"/>
                    <StyledBalance>
                        <StyledValue>{displayTshareBalance}</StyledValue>
                        <Label text="STRAW Available"/>
                    </StyledBalance>
                </StyledBalanceWrapper>

                <StyledBalanceWrapper>
                    <TokenSymbol symbol="TBOND"/>
                    <StyledBalance>
                        <StyledValue>{displayTbondBalance}</StyledValue>
                        <Label text="CARAML Available"/>
                    </StyledBalance>
                </StyledBalanceWrapper>
            </Balances>
        </Modal>
    );
};

const StyledValue = styled.div`
  //color: ${(props) => props.theme.color.grey[300]};
  font-size: 30px;
  font-weight: 700;
`;

const StyledBalance = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Balances = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
`;

const StyledBalanceWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 ${(props) => props.theme.spacing[3]}px;
`;

export default AccountModal;
